// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:600px){#custom-img-600{display:none}#custom-row-600{display:flex;justify-content:center;align-content:stretch}#custom-col-600{max-width:100%}}", ""]);
// Exports
module.exports = exports;
